/**
 * Download progress without a round trip (models.md §6.2, §12). Mounted once at the app root: a `model`
 * event (throttled to 4 a second by the engine) writes its install state straight into
 * ['models', 'installs'], so the progress bars, the list status and the status cluster move at once.
 * Invalidation of every model key by events (including `entitlement` → ['models']) is
 * engine-client/invalidate.ts's, the one table of event → keys; this only saves the refetch's latency.
 */

import { useQueryClient } from '@tanstack/react-query';
import type { ModelInstallState } from '@digester/core';
import { useEngineEvent } from '../engine-client/EngineProvider.js';
import { modelKeys } from '../settings/models/data.js';

export function useModelEvents(): void {
  const qc = useQueryClient();
  useEngineEvent((event) => {
    if (event.type === 'model') {
      qc.setQueryData<ModelInstallState[]>(modelKeys.installs(), (old) => {
        const list = old ?? [];
        const i = list.findIndex((s) => s.modelId === event.install.modelId);
        return i < 0 ? [...list, event.install] : list.map((s, j) => (j === i ? event.install : s));
      });
    }
  });
}

/** The component form, for the app root. */
export function ModelEvents(): null {
  useModelEvents();
  return null;
}
